const CardanoCnt = {
  symbol: "ADA",
  name: "cardano",
  meta: {
    title: "Buy Cardano | Cardano Sale | ADA prices and charts",
    description:
      "Cardano Digital Currency (ADA) is one of the most promising digital currency projects and is known as the third generation of cryptocurrencies. Kevin Nick Market has made it possible to buy and sell Cardano with the best price, the safest transaction and the lowest commission.",
    keywords: "Cardano, buy Cardano, sell Cardano, price Cardano",
  },
  scripts: {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "چگونه کاردانو بخریم؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در پلتفرم معاملاتی کوین‌نیک مارکت می‌توانید با کارت بانکی عضو شتاب و کمترین کارمزد، اقدام به خرید  کادرانو کنید.",
        },
      },
      {
        "@type": "Question",
        name: "بهترین کیف پول کاردانو کدام است؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " کیف پول رسمی کاردانو، دایدالوس (Deadalus) است که نام آن بر اساس یکی از مشهور‌ترین معماران و مخترعین افسانه‌های یونانی گرفته شده است. این کیف پول توسط IOHK توسعه یافته و اجازه می‌دهد یک نسخه کامل از بلاک چین کاردانو را روی سیستم خود دانلود و به شکل مستقل تمامی تراکنش‌های این شبکه را تایید کنید. این ویژگی اجازه می‌دهد تا به حداکثر امنیت شبکه دست پیدا کنید و از سرورهای متمرکز خارجی خبری نباشد. دیگر کیف پول‌هایی که از کاردانو پشتیبانی می‌کنند عبارتند از: کیف پول یوروی (Yoroi)، کیف پول اکسودوس (Exodus)، کیف پول تراست (Trust)، کیف پول لجر (Ledger) و کیف پول ترزور (Trezur) و کیف پول کوین نیک مارکت.",
        },
      },
      {
        "@type": "Question",
        name: " آیا می‌توان کاردانو را در کوین نیک مارکت نگهداری کرد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "در کوین‌نیک مارکت یک کیف پول اختصاصی و امن دارید، که می‌توانید رمزارزهیاتان را در آن نگهداری کنید. در این صورت دیگر هیچ نگرانی و استرسی بابت مسدود شدن موجودی‌تان در صرافی‌های خارجی به علت تحریم‌های مالی علیه ایران نخواهید داشت.",
        },
      },
      {
        "@type": "Question",
        name: "آیا کاردانو ارزش سرمایه‌گذاری دارد؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: " سرمایه‌گذاران و تریدرها به رشد کاردانو و ارزش پیش‌بینی شده آن اتفاق نظر دارند. کاردانو پس از سال‌ها ثبات قیمت، آماده است تا یک بار دیگر قیمت خود را افزایش داده و پتانسیل واقعی خود را نشان دهد. همچنین، کاردانو بسیار جدید است، به این معنی که سرمایه‌گذاران هنوز فرصت دارند تا در میان معدود افرادی قرار بگیرند که بیشترین رشد اقتصادی را تجربه می‌کنند. کاردانو در مقایسه با بسیاری دیگر ارز رمزها دیر به این بازار وارد شد، اما این دارایی دیجیتال سرشار از نوآوری است و همین موضوع به رشد چشمگیر و باور نکردنی قیمت آن دامن می‌زند. پتانسیل کاردانو اگر بیش از قبل نباشد، هنوز بسیار بالا است.",
        },
      },
    ],
  },
  faq: [
    {
      question: "How to buy Cardano?",
      answer:
        "In Quinnik Market trading platform, you can buy Cardano with Shetab member bank card and the lowest fee.",
      id: "toggler1",
    },
    {
      question: "What is Cardano's best wallet?",
      answer: "Cardano_wallet",
      id: "toggler2",
    },
    {
      question: "Can Cardano be kept at Coinnik Market?",
      answer: "Keep_wallet_description",
      id: "toggler3",
    },
    {
      question: "Is Cardano worth the investment?",
      answer: "Cardano_investment",
      id: "toggler4",
    },
  ],
  body: [
    [
      {
        heroTitle: "General information about Cardano",
        subTitle: "What is Cardano?",
        content: "Cardano_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "History of Cardano",
        content: "cardano_history_description",
        btnTitle: "Buy and sell Cardano Coin",
        btnLink: "",
        linkTitle: "Read more on the blog",
        Link: "",
      },
    ],
    [
      {
        heroTitle:
          "Cardano buying and selling without intermediaries in Quinnic Market",
        subTitle: "Buy Cardano Coin",
        content: "Buy_Cardano_description",
        btnTitle: "",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
      {
        heroTitle: "",
        subTitle: "Sale Cardano Coin",
        content: "sale_Cardano_description",
        btnTitle: "Buy and sell Cardano Coin",
        btnLink: "",
        linkTitle: "",
        Link: "",
      },
    ],
  ],
  posts: [
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
    [
      {
        heroTitle: "Technical analysis ; Candle patterns",
        content: "Technical_analysis",
        linkTitle: "Read more",
        time: "{{number}}Days ago",
      },
    ],
  ],
  blogTitle: "The latest cardano analysis on the blog",
  informationTitle: "cardano market statistics and information",
};

export default CardanoCnt;
